let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("enkb5")).then(() => parcelRequire('4deUn'));